<template>
	<div class="layout-preview-item"
	     :id="dataset.id">
		<div class="action-bar row">
			<div class="col-6 template-info">
				<span class="_part _title">{{ template.title }}</span>
				<span class="_part _id">{{ template.id }}</span>
				<span class="_part _path">{{ template.path }}</span>
			</div>
			<div class="col-6 button-group">
				<b-button class="ml-2"
				          size="sm"
				          @click="handleMoveClick">
					verschieben
				</b-button>
				<b-button class="ml-2"
				          size="sm"
				          variant="danger"
				          @click="handleDeleteClick">
					löschen
				</b-button>
			</div>
		</div>
		<div class="preview-item 96a5e0e1b988103acd3676a3bfca66930fb87db" ref="preview-item">
			<div class="spinner-wrap">
				<erco-cloak ref="preview-item-cloak" :vCenter="false"></erco-cloak>
			</div>
		</div>
		<b-modal id="delete-confirmation"
		         ref="deleteConfirmation"
		         class="delete-confirmation-modal"
		         title="Seite löschen"
		         closeTitle="Abbrechen"
		         @ok="handleDeleteConfirmationModalClick">
			<p class="_template">
				<span class="_path">{{this.dataset.templatePath}}</span>
				<span class="_id">{{this.dataset.templateId}}</span>
			</p>
			<p class="_infotext">
				<span v-if="textFieldCount || imgFieldCount"
			       class="_fields">
				   {{ `Wollen Sie diese Seite mit ${textFieldCount ? `${textFieldCount} Text${textFieldCount > 1 ? 'en':''}` : ''} ${(textFieldCount && imgFieldCount) ? 'und': ''} ${imgFieldCount ? `${imgFieldCount} Bild${imgFieldCount > 1 ? 'ern':''}` : ''} wirklich löschen?` }}
				</span>
				<span v-else>
					Wollen Sie diese Seite wirklich löschen?
				</span>
			</p>

		</b-modal>
	</div>
</template>

<script>

import Vue from 'vue';
import Const from '@/constants';
import InfoText from '@/helper/infoTextHelper';

import renderHelper from '@/helper/renderHelper';

import ErcoCloak from '@/components/molecules/ErcoCloak';


/* SiteMixins */
import ContentGrid from '@/mixins/preview/ContentGrid';

/* Abhängig von der Seite (Bestimmung anhand des Templatepfads),
	der Preview-Komponente einen seiten-spezifischen Mixin beiführen */
const siteMixins = {
	'career_content_grid.htm': ContentGrid,
};


export default {
	name: 'ErcoLayoutPreviewItemAtom',

	props: {
		dataset: {
			type: Object,
			required: true,
		},
		objecttype: {
			type: String,
			default: '-1',
		},
		objectname: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			$previewItem: null,
			componentIsAlreadyInjected: false,
			siteType: '',
			siteTitle: '',
		};
	},

	components: {
		ErcoCloak,
	},

	watch: {
		dataset() {
			this.updatePreview();
		},

		objectname(newObjectname) {
			this.$set(this.$previewItem.$data, 'objectname', newObjectname);
		},
	},

	mounted() {
		this.updatePreview();
	},

	computed: {
		previewItemWrapperAttrs() {
			const attrs = {
				class: ['wrapper'],
			};

			this.dataset.bodytagAttrs.replace(/(.*?)="(.*?)"/g, (whole, attrName, attrValue) => {
				const lcAttrName = attrName.trim().toLowerCase();

				if (!attrs[lcAttrName]) {
					attrs[lcAttrName] = [];
				}

				attrs[lcAttrName].push(attrValue.trim());
			});

			return Object.keys(attrs).map((attrKey) => {
				const attrValue = Array.isArray(attrs[attrKey]) ?
									attrs[attrKey].join(' ') : attrs[attrKey];
				return `${attrKey}="${attrValue}"`;
			}).join(' ');
		},

		imgFieldCount() {
			return Object.values(this.dataset.items).reduce((acc, item) => {
				let newAcc = acc;
				if (item.typ === 'bild' && item.value) {
					newAcc += 1;
				}
				return newAcc;
			}, 0);
		},

		textFieldCount() {
			return Object.values(this.dataset.items).reduce((acc, item) => {
				let newAcc = acc;
				if (item.typ === 'text' && item.value) {
					newAcc += 1;
				}
				return newAcc;
			}, 0);
		},

		template() {
			return {
				title: this.dataset.templateTitle || '',
				id: this.dataset.templateId || '',
				path: this.dataset.templatePath || '',
			};
		},
	},

	methods: {
		updatePreview() {
			if (!this.dataset.loading) {
				this.injectPreviewComponent();
			}

			this.updateRenderPreviewData(this.dataset);
		},

		injectPreviewComponent() {
			if (this.componentIsAlreadyInjected) {
				return;
			}

			this.componentIsAlreadyInjected = true;

			const previewItemContainer = this.$refs['preview-item'];
			const cssStyles = [];
			const imgKeys = [];

			this.specification = this.dataset.specification;
			this.category = this.dataset.category;
			this.idArea = this.dataset.idArea;
			this.idObject = this.dataset.idObject;
			this.isGenus = this.dataset.isGenus;

			/* Entfernung von style-Tags, da sie von vue.js nicht geparst werden
				und ein Fehler werfen */
			const sanitizedTemplate =
				this.dataset.template &&
				this.dataset.template
					.replace(/style\s*=\s*"(.*?)"/g, (match, group) => {
						const cleanedGroup = group.replace(/(min-){0,1}height.*?(;|$)/g, '');
						return `style="${cleanedGroup}"`;
					})
					.replace(/<\s*style\s*>([\s\S.]*?)<\s*\/\s*style\s*>/mg, (match, firstGroup) => {
						if (firstGroup) {
							cssStyles.push(firstGroup);
						}
						return '';
					})
					.replace(/<\s*km(\s[\s\S]*?){0,1}\s*>([\s\S]*?)(<\s*\/\s*km\s*>){0,1}/mg,
						(match, groupOne, groupTwo) => `<div${groupOne || ''}>${groupTwo || ''}</div>`)
					/* JS-Code kann nicht direkt extrahiert werden und sollte über Mixins
						(mixins/preview) seiten-spezifisch eingeführt werden */
					.replace(/<\s*?script[\s\S]*?>[\s\S]*?<\s*?\/\s*?script\s*?>/mg, '')
					.replace(/v-html="(\s*.+?\s*)"/mg, (match, key) => {
						let subtype = this.dataset.items[key].typ;
						if (subtype === 'text' && this.dataset.items[key].enum) {
							subtype = 'enum';
						}
						const editableSubAttr = subtype === 'enum' ? 'data-list-select' : 'data-text-edit';
						const editableAttr = `data-editable ${editableSubAttr}`;
						const position = this.dataset.items[key].U_Position;
						const modifiedAttrs = `${match} @click="handleItemClick('${key}', $event)" ${editableAttr} data-dev-info="{ type: 'item', id: '${key}', subtype: '${subtype}', position: ${position} }"`;
						return modifiedAttrs;
					})
					.replace(/v-bind:src="(\s*.+?\s*)"/mg, (match, key) => {
						const subtype = this.dataset.items[key].typ;
						const position = this.dataset.items[key].U_Position;
						const sUrbild = this.dataset.items[key].S_Urbild;
						const modifiedAttrs = `${match} @click="handleItemClick('${key}', $event)" data-editable data-dev-info="{ type: 'item', id: '${key}', subtype: '${subtype}', position: ${position}, image: '${sUrbild}' }" v-bind:class="{ loading: ${key}_loading }"`;
						imgKeys.push(key);
						return modifiedAttrs;
					})
					.replace(new RegExp(`(>[\\w\\d]*?)(${this.objectname})`, 'g'),
						(match, prefix) => `${prefix}{{objectname}}`);

			const cssRules = this.parseCSSStyles(cssStyles);

			const loadingData = imgKeys.reduce((fields, imgKey) => {
				fields[`${imgKey}_loading`] = false;
				return fields;
			}, {});
			const extendedData = {
				...this.dataset.data,
				...loadingData,
				objectname: this.objectname,
				bgColorGrayscaleThreshold: 127.5,
				invertEdit: 'false',
			};

			const specificMixins = [];

			if (siteMixins[this.dataset.templatePath]) {
				specificMixins.push(siteMixins[this.dataset.templatePath]);
			}

			this.$refs['preview-item-cloak'].$destroy();
			previewItemContainer.innerHTML = '';

			const wrappedSanitizedTemplate =
				`<div class="preview-item 96a5e0e1b988103acd3676a3bfca66930fb87db">
					<div :data-invert-edit="invertEdit" ${this.previewItemWrapperAttrs}>
						${sanitizedTemplate}
					</div>
				</div>`;

			this.$previewItem = new Vue({
				name: 'ErcoLayoutPreviewDynItem',
				mixins: specificMixins,
				// template string here
				template: wrappedSanitizedTemplate,
				// makes $parent work
				parent: this,
				// any props the component should receive.
				// reference to data in the template will *not* have access the the current
				// components scope, as you create a new component
				data: extendedData,
				mounted() {
					cssRules.forEach((rule) => {
						const selectedEls = Array.from(this.$el.querySelectorAll(rule.selector));
						selectedEls.forEach(el => el.setAttribute('style', rule.props));
					});

					const wrapperEl = this.$el.querySelector('.wrapper');
					if (!wrapperEl) {
						return;
					}

					const color = window.getComputedStyle(wrapperEl).backgroundColor;

					if (color && this.hasDarkBackgroundColor(color)) {
						this.invertEdit = 'true';
					}
				},
				methods: {
					handleItemClick(key, $event) {
						this.$parent.handleItemClick(key, $event);
					},
					hasDarkBackgroundColor(foundColor) {
						const matches =
							foundColor.match(/\((\d{1,3}), (\d{1,3}), (\d{1,3}).*?\)/);

						if (!matches) {
							return false;
						}

						matches.shift();

						const erg =
							(
								parseInt(matches[0], 10) +
								parseInt(matches[1], 10) +
								parseInt(matches[2], 10)
															) / 3;

						const opacityMatch =
							foundColor.match(/\(\d{1,3}, \d{1,3}, \d{1,3}, (\d\.\d*|\d).*?\)/);

						const opacity = (opacityMatch) ? parseInt(opacityMatch[1], 10) : 1;

						if (erg < this.bgColorGrayscaleThreshold && opacity !== 0) {
							return true;
						}

						return false;
					},
				},
				// possibly other options
			}).$mount(previewItemContainer);
		},

		parseCSSStyles(cssStyles) {
			const cssRules = [];
			cssStyles.forEach((style) => {
				style.replace(/(\s*[\s\S]*?)\s*\{\s*([\s\S]*?)\s*\}/mg, (match, firstGroup, secondGroup) => {
					cssRules.push({
						selector: firstGroup.trim(),
						props: `${secondGroup.split(';')
						                     .map(item => item.trim())
						                     .filter(item => item.trim().length > 0)
						                     .join('; ')};`,
					});
				});
			});
			return cssRules;
		},

		updateRenderPreviewData(dataset) {
			if (!this.$previewItem || !this.$previewItem.$data || !dataset) {
				return;
			}

			Object.keys(dataset.data).forEach((key) => {
				const item = dataset.items[key];
				if (item && item.typ === 'bild') {
					renderHelper.getImage(item, (img, loading) => {
						this.$set(this.$previewItem.$data, key, img);
						this.$set(this.$previewItem.$data, `${key}_loading`, loading);
					});
				} else {
					this.$set(this.$previewItem.$data, key, dataset.data[key]);
				}
			});
		},

		handleItemClick(key, event) {
			let type = '';
			let view = '';
			let title = `Position ${this.dataset.items[key].nummer}`;
			let titleAdditional = '';
			let outputData = null;
			let resetButton = null;

			if (event.target) {
				const labelEl = event.target.previousElementSibling;

				if (labelEl && labelEl.classList.contains('label')) {
					titleAdditional = title;
					title = labelEl.innerHTML;
				}
			}

			if (this.dataset.items[key].enum) {
				type = 'enum';
				view = 'erco-sidebar-dropdown';
				outputData = [Object.assign({ key }, this.dataset.items[key])];
			} else if (this.dataset.items[key].typ === 'bild') {
				type = 'image';
				view = 'erco-sidebar-image-editor';
				title = this.dataset.items[key].S_Urbild;
				outputData = Object.assign({ key }, this.dataset.items[key]);
				resetButton = { visible: true };
			} else {
				type = 'text';
				view = 'erco-sidebar-tabbed-text-input';

				const tabs = Const.langs.map((lang) => {
					const text = (this.dataset.translations[lang.key] &&
					              this.dataset.translations[lang.key].items[key] &&
					              this.dataset.translations[lang.key].items[key].value) || '';
					return {
						key,
						tabKey: lang.key,
						label: lang.text,
						text,
						toBeFetched: this.dataset.translations[lang.key] === null,
					};
				});

				const charlength = parseInt(this.dataset.items[key].charlength, 10) || -1;

				outputData = {
					tabChangeAction: 'getObjectSiteTranslation',
					selectedTabKey: this.$store.state.objectsetup.current.sprache,
					tabs,
					charlength,
				};

				if (charlength > -1) {
					titleAdditional = `(max. ${charlength} Zeichen)`;
				}
			}

			const sidebarData = {
				visible: true,
				key: 'layout-preview-item',
				view,
				fixed: true,
				outputData,
				context: {
					dispatchActionName: 'updateObjectSiteItemsAndSave',
					value: {
						siteId: this.dataset.id,
						type,
					},
				},
				resetButton,
				title,
				titleAdditional,
				info: InfoText.for('layout.itemEdit'),
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},

		handleMoveClick() {
			this.$store.dispatch('setLayoutAction', {
				type: 'move',
				values: this.dataset,
			});
		},

		handleDeleteClick() {
			this.$refs.deleteConfirmation.show();
		},

		handleDeleteConfirmationModalClick() {
			this.$store.dispatch('deleteSite', this.dataset.id);
		},
	},
};
</script>
<style lang="scss">
	@keyFrames opacityFade {
		0% { opacity: 0; }
		100% { opacity: 100; }
	}

	.layout-preview-item {
		position: relative;

		&:hover {
			& > .action-bar {
				opacity: 1;
				transition: opacity 0.3s;
			}
		}

		& > .action-bar {
			background-color: rgba(2, 117, 216, 0.7);
			left: 0;
			margin: 0;
			padding: 0.5rem 1rem;
			position: absolute;
			top: 0;
			width: 100%;
			z-index: 999;
			opacity: 0;

			transition: opacity 0.2s;

			& > .template-info {
				color: rgba(255, 255, 255, 1);
				font-size: 1rem;
				padding-left: 3rem;

				& > ._part {
					vertical-align: baseline;
				}

				& > ._title {
				}
				& > ._id {
					margin-left: 2rem;
					font-size: 0.8rem;
				}
				& > ._path {
					margin-left: 0.5rem;
					font-size: 0.8rem;
				}
			}

			& > .button-group {
				text-align: right;
				padding-right: 0;
				& > .btn {
					min-width: 7rem;
				}
			}
		}

		& > .preview-item {
			font-family: Rotis;
			position: relative;

			[data-invert-edit="true"] {
				color: #fff;

				[data-editable]:not(img) {
					&[data-text-edit]::after {
						background-image: url('~@/assets/img/edit.invers.png');
					}

					&[data-list-select]::after {
						background-image: url('~@/assets/img/list-select.invers.png');
					}
				}
			}

			[data-editable]:not(img) {
				cursor: pointer;
				width: 100%;
				min-height: 1rem;

				&::after {
					content: '';
					display: inline-block;
					background-size: 100% 100%;
					background-repeat: no-repeat;
					height: 1em;
					margin-left: 1rem;
					vertical-align: baseline;
					width: 1em;
					position: absolute;
				}

				&:empty {
					&::after {
						margin: 0;
					}
				}

				&[data-text-edit]::after {
					background-image: url('~@/assets/img/edit.png');
				}

				&[data-list-select]::after {
					background-image: url('~@/assets/img/list-select.png');
				}

			}

			& > .wrapper {
				padding: 2.6rem 0 0;

				img[data-editable] {
					border: 1px solid transparent;

					&.loading {
						animation: opacityFade 1s linear infinite alternate-reverse;
					}
				}
			}


			& > .spinner-wrap {
				height: 10rem;
			}

			/*
				Fix für die unterschiedlichen zum Einsatz kommen Bootstrap-Versionen;
					für die Grid-Konstruktion, nutzt
						* der LSP-Client eine Version auf Basis von Flexbox
						* das CMS eine Version auf Basis von prozentualen Breitenangaben und
							Floating (Ansatz vor Flexbox)
			*/
			.row:not(.tab-pane) {
				display: block;
			}
		}

		& > .delete-confirmation-modal {
			.modal {
				display: block;
			}

			._infotext {
				margin: 0.5rem 0 2rem;
			}

			._template {
				margin: 0.5rem 0 2rem;

				> ._path {
					font-weight: bold;
				}

				> ._id {
					font-size: 0.9rem;
					margin-left: 1rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// PreviewItem.vue?033d0e9a